namespace TabAurous.OMS {
    export namespace PartySelectService {
        export const baseUrl = 'OMS/PartySelect';

        export declare function List(request: PartyRequest, onSuccess?: (response: Serenity.ListResponse<AccountLedgerRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "OMS/PartySelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>PartySelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
